<template>
  <el-dialog
    title="批量结案"
    :visible.sync="dialogVisible"
    width="720px"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <el-form
        :inline="true"
        label-position="top"
        :model="formInline"
        class="demo-form-inline"
        ref="form"
      >
        <el-form-item label="处置措施" style="width: 100%;">
          <el-input
            type="textarea"
            style="white-space: pre-wrap;"
            ref="handleDetail"
            :autosize="{ minRows: 4, maxRows: 8 }"
            v-model="formInline.handleDetail"
            placeholder="处置措施"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="demo-drawer__footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="loading"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { batchHandleByIds } from "@/api/point.js";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    selectedIdOptions: {
      type: Object,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      formInline: {
        handleDetail: ""
      },
      loading: false
    };
  },
  mounted() {
    console.log(this.selectedIdOptions);
  },
  methods: {
    async onSubmit() {
      this.loading = true;
      const res = await batchHandleByIds({
        ...this.formInline,
        ids: this.selectedIdOptions
      });
      this.loading = false;
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.handleClose();
        this.$emit("refreshList");
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    }
  },
  computed: {},
  watch: {
    "formInline.handleDetail": {
      deep: true,
      handler: function(newVal, oldVal) {
        if (!!!newVal) return;

        this.$nextTick(() => {
          const inputElement = this.$refs.handleDetail.$el.querySelector(
            "textarea"
          );
          const cursorPosition = inputElement.selectionStart;
          this.formInline.handleDetail = newVal.replace(/ /g, "\u3000");
          inputElement.setSelectionRange(cursorPosition, cursorPosition);
        });
      }
    }
  }
};
</script>

<style scoped lang="less">
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;
  background: none;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 24px;
}

.container-dialog {
  padding: 14px 24px 24px;
}
/deep/.el-form-item {
  width: calc(50% - 12px);
  margin-bottom: 20px;
  margin-right: 8px;
  .el-form-item__label {
    margin: 0;
    padding: 0;
    margin-bottom: 8px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #494c4f;
    line-height: 1;
  }
  .el-select {
    width: 100%;
  }
  .el-input__inner {
    height: 40px;
    width: 100%;
  }
}
/deep/.demo-drawer__footer {
  width: 100%;
  padding: 24px;
  position: absolute;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: flex-end;
  background: #fff;
}
/deep/.el-upload,
/deep/.el-upload-dragger {
  width: 212px;
  height: 212px;
}
/deep/.el-upload .el-upload__input {
  display: none;
}
.el-upload__text {
  height: auto;
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 16px;
  color: #494c4f;
  display: inline-block;
  margin: 8px 0;
}
.tip {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 14px;
  color: #92979c;
  margin-top: 8px;
}
/deep/.el-upload--picture-card {
  line-height: 1;
  padding-top: 54px;
}
.list-pic {
  /deep/.el-upload--picture-card {
    display: none;
  }
  /deep/.el-upload-list--picture-card {
    img {
      width: 212px;
      height: 212px;
    }
  }
}
/deep/.container-dialog {
  padding-bottom: 112px;
}
/deep/.avatar-uploader {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/pages/reportproblemAnalysis/components/batchHandleDialog.vue